
import React, {
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useRef,
    useState,
} from "react";
import SelectEstablishment from "../../../../components/MyCustom/SelectEstablishment";
import SelectStore from "../../../../components/MyCustom/SelectStore";
import TableCustom from "../../../../components/MyCustom/TableCustom";
import Breadcrumb from "../../../../components/bootstrap/Breadcrumb";
import Button from "../../../../components/bootstrap/Button";
import Card, { CardBody } from "../../../../components/bootstrap/Card";
import ModalEntradaInsumo from "../../../../components/modals/insumoLoja/modalEntradaInsumos";
import ModalHistoricoInsumos from "../../../../components/modals/insumoLoja/modalHistoricoInsumos";
import { DefaultContext } from "../../../../contexts/default";
import InsumosDB from "../../../../database/wrappers/insumos";
import InsumosStoreDB from "../../../../database/wrappers/insumosStore";
import Money from "../../../../helpers/utils/money/money";
import PreAlert from "../../../../helpers/utils/preAlert";
import useDarkMode from "../../../../hooks/useDarkMode";
import Page from "../../../../layout/Page/Page";
import PageWrapper from "../../../../layout/PageWrapper/PageWrapper";
import SubHeader, {
    SubHeaderLeft
} from "../../../../layout/SubHeader/SubHeader";
import { demoPages } from "../../../../menu";
import ImportInsumeCsv from "../../../../utils/csv/importInsume";
import ModalAlteraQtd from "../../../../components/modals/insumoLoja/modalAlteraQtd";
import dateFormat from "dateformat";
import Popovers from "../../../../components/bootstrap/Popovers";
import { getFloatCMV } from "../../../../utils/cmv/convertQtd";

const EntradaInsumo = () => {
    const { darkModeStatus } = useDarkMode();

    const { estabSelected, storeSelected, onShowAlert } = useContext(DefaultContext);

    const [allProducts, setAllProducts] = useState([]);
    const [allInsumes, setAllInsumes] = useState([]);
    const [renderList, setRenderList] = useState([]);
    const [inputtedList, setInputtedList] = useState([]);
    const [selectedInsume, setSelectedInsume] = useState(null)

    const [loadImport, setloadImport] = useState(false);
    const [showModal, setshowModal] = useState(false);
    const [showHistoryModal, setShowHistoryModal] = useState(false)
    const [qtdModal, setQtdModal] = useState(false)

    const [showSaidaModal, setSaidaModal] = useState(false)


    const inputFile = useRef(null)

    const handleOpenModalEdit = (item) => {
        setSelectedInsume(item)
        setshowModal(true)
    }

    const handleOpenEditQtd = (item) => {
        setSelectedInsume(item)
        setQtdModal(true)
    }

    const handleCloseEditQtd = (item) => {
        setSelectedInsume(item)
        setQtdModal(false)
    }

    const handleCloseModalEdit = () => {
        setSelectedInsume(null)
        setshowModal(false)
    }

    const handleOpenHistoryModal = (item) => {
        setSelectedInsume(item)
        setShowHistoryModal(true)
    }
    const handleCloseHistoryModal = () => {
        setSelectedInsume(null)
        setShowHistoryModal(false)
    }

    // import csv
    const onClickImport = useCallback(() => {
        inputFile.current.click();
    }, [inputFile])

    const handleFiles = useCallback(e => {
        if (!estabSelected) return;
        setloadImport(true)
        const [file] = Array.from(e.target.files)
        new ImportInsumeCsv(estabSelected)
            .import(file)
            .then(() => onShowAlert(PreAlert.success('Registro(s) cadastrado(s) com sucesso')))
            .catch((error) => onShowAlert(PreAlert.error(error || 'Falhou ao cadastrar o(s) registro(s)')))
            .finally(() => {
                setloadImport(false);
                e.target.value = '';
            })
    }, [estabSelected])

    useEffect(() => {
        setAllProducts([])
        setAllInsumes([])
        if (!estabSelected || !storeSelected) return;
        const onInsumos = new InsumosDB(estabSelected).on(
            setAllProducts,
        )

        const onInsumosStore = new InsumosStoreDB(estabSelected, storeSelected).on(
            setAllInsumes,
        )

        return () => {
            onInsumos();
            onInsumosStore();
        }
    }, [estabSelected, storeSelected]);

    useEffect(() => {
        setRenderList([])
        if (!allProducts.length) return;

        const productsData = allProducts.map((prod) => {
            const findedInsume = allInsumes.find(aux => aux.id == prod.id)
            return {
                id: prod.id,
                name: prod.name,
                unit: prod.unit,
                qtd: findedInsume ? findedInsume.qtd : 0,
                price: findedInsume ? Number(findedInsume?.price) : 0,
                lastEntrance: findedInsume?.lastEntrance || "",
                finded: !!findedInsume
            }
        });

        setRenderList(productsData);
    }, [allProducts, allInsumes]);

    useEffect(() => {
        const filledItems = renderList.filter(
            (item) => {
                const validQtd = typeof item.qtd === 'number' && item.qtd > 0;
                const validPrice = typeof item.price === 'number' && item.price > 0;
                return validQtd && validPrice;
            }
        );
        setInputtedList(filledItems);
    }, [renderList]);



    const columns = useMemo(
        () => [
            {
                label: "Id",
                field: "id",
                hidden: true,
                noExport: true
            },
            {
                label: "Nome",
                field: "name",
            },
            {
                label: 'Última Entrada',
                field: 'lastEntrance',
                format: ({ lastEntrance }) =>
                    lastEntrance ? dateFormat(lastEntrance.toDate(), 'dd/mm/yyyy HH:MM') : '',
                isDate: true
            }
            ,
            {
                label: "Unidade",
                field: "unit",
            },
            {
                label: "QTD",
                field: "{row}",
                format: row => getFloatCMV(row.qtd),
                formatExport: row => getFloatCMV(row.qtd)
            },
            {
                label: "Preço Unitário",
                field: "price",
                format: row => Money.centsToMaskMoney(row.price),
                isCurrency: true
            },
            // {
            //     label: "Preço Total",
            //     field: "price",
            //     format: row => Money.centsToMaskMoney(row.price * row.qtd),
            //     formatExport: value => Money.centsToMaskMoney(value * value.qtd)
            // },
            {
                label: 'Ações',
                field: 'actions',
                format: row => (
                    <div className='w-50 d-flex gap-2'>
                        <Popovers
                            trigger="hover"
                            title="Nova entrada"
                        >
                            <Button
                                color={darkModeStatus ? 'light' : 'dark'}
                                icon="plus"
                                hoverShadow="sm"
                                size="sm"
                                text=''
                                onClick={() => handleOpenModalEdit(row)}
                            />
                        </Popovers>
                        <Popovers
                            trigger="hover"
                            title="Editar ultima entrada"
                        >

                            <Button
                                color={darkModeStatus ? 'light' : 'dark'}
                                icon="pencil"
                                hoverShadow="sm"
                                size="sm"
                                text=''
                                onClick={() => handleOpenEditQtd(row)}
                            />
                        </Popovers>

                        <Popovers
                            trigger="hover"
                            title="Historico de entradas"
                        >
                            <Button
                                color={darkModeStatus ? 'light' : 'dark'}
                                icon="eye"
                                hoverShadow="sm"
                                size="sm"
                                text=''
                                onClick={() => handleOpenHistoryModal(row)}
                            />
                        </Popovers>
                    </div>
                ),
                noExport: true
            },
        ],
        []
    );

    return (
        <>
            <PageWrapper title={demoPages.pdvLoja.subMenu.entradaInsumos.text}>
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: "PDV Loja", to: "/pdvLoja" },
                                { title: "Estoque Insumos", to: "/pdvLoja/Estoque Insumos" },
                            ]}
                        />
                    </SubHeaderLeft>

                </SubHeader>

                <Page container="fluid">
                    <Card>
                        <CardBody className="table-responsive p-5">
                            <div className="row d-flex align-items-center mx-1">
                                <SelectEstablishment />
                                <SelectStore />
                            </div>
                            <TableCustom
                                columns={columns}
                                rows={renderList}
                                fileName="Estoque-insumos"
                            />
                        </CardBody>
                    </Card>
                </Page>
            </PageWrapper>

            <ModalEntradaInsumo
                open={showModal}
                handleOpen={handleCloseModalEdit}
                insumoSelected={selectedInsume}
            />

            <ModalAlteraQtd
                open={qtdModal}
                handleOpen={handleCloseEditQtd}
                insumoSelected={selectedInsume}
            />

            <ModalHistoricoInsumos
                open={showHistoryModal}
                handleOpen={handleCloseHistoryModal}
                insumoSelected={selectedInsume}
            />
        </>
    );
};

export default EntradaInsumo;
